module.exports = __webpack_public_path__ + "static/media/Egg.4ac2d858.png";